// @flow
import {
  either,
  isEmpty,
  isNil,
  indexBy,
  prop,
  path,
} from 'ramda'

import {unwrapNodes} from 'utils/GraphQL'

import type {Change} from './types'
import Value from '../ui/Value'

const indexDomains = indexBy(prop('databaseId'))

const isBlank = either(isNil, isEmpty)

const domainDatabaseId = path(['domain', 'databaseId'])

class FetchFields {
  availableDomains: Object
  destroyPolicy: boolean
  nextBody: string
  nextDomainDatabaseId: string
  nextTitle: string
  policy: Object

  constructor(change: Change) {
    const {policy, availableDomains, command = '{}'} = change
    const body = JSON.parse(command)
    const {
      title: nextTitle,
      body: nextBody,
      destroy: destroyPolicy,
      domainDatabaseId: nextDomainDatabaseId = '__new__',
    } = body

    this.policy = policy
    this.nextTitle = nextTitle
    this.nextBody = nextBody
    this.nextDomainDatabaseId = nextDomainDatabaseId === '__new__'
      ? domainDatabaseId(policy)
      : nextDomainDatabaseId
    this.availableDomains = indexDomains(unwrapNodes(availableDomains))
    this.destroyPolicy = destroyPolicy
  }

  titleBodyAndDomainId(): Value[] {
    if (isBlank(this.policy)) {
      return [
        new Value('', this.nextTitle, {isNew: true}),
        new Value('', this.nextBody, {isNew: true}),
        new Value('', this.nextDomainDatabaseId, {isNew: true}),
      ]
    }

    const {title: prevTitle, body: prevBody} = this.policy
    return [
      new Value(prevTitle, this.nextTitle),
      new Value(prevBody, this.nextBody),
      new Value(domainDatabaseId(this.policy), this.nextDomainDatabaseId),
    ]
  }

  call() {
    const [titleValue, bodyValue, domainDatabaseIdValue] = this.titleBodyAndDomainId()

    return {
      title: titleValue,
      body: bodyValue,
      availableDomains: this.availableDomains,
      destroyPolicy: !!this.destroyPolicy,
      domainDatabaseId: domainDatabaseIdValue,
    }
  }
}

export default (change: Object): {
  availableDomains: any,
  body: Value,
  destroyPolicy: boolean,
  domainDatabaseId: Value,
  title: Value,
} => (new FetchFields(change)).call()
